import { Component, input } from '@angular/core';

@Component({
  selector: 'iw-badge',
  template: `
    <div
      class="badge d-inline-flex justify-center align-center"
      [class.rounded]="rounded()"
      [class.small]="size() === 'small'"
      [class.medium]="size() === 'medium'"
      [style.background-color]="color()"
    >
      @if (showZero() || value() !== 0) {
        <span>{{ value() }}</span>
      }
    </div>
  `,
  styleUrl: 'badge.component.scss',
})
export class BadgeComponent {
  value = input<number>(0);
  size = input<'small' | 'medium'>('medium');
  color = input<string>('var(--additional-info)');
  showZero = input<boolean>(true);
  rounded = input<boolean>(false);
}
